module.exports = __webpack_public_path__ + "img/sound_on_hover.4252ad03.svg";